import axios from 'axios'
import Vue from 'vue'
import i18n from '../../../../i18n';

const state = {
    token: localStorage.getItem('user-token') || '',
    loading: true,
    tags: [],
    tag: {},
    message: {},
    tagId: null
}

const getters = {
    getAllTags(state){
        return state.tags;
    },
    getTag(state){
        return state.tag;
    },
    getTagId(state){
        return state.tagId
    },
    updateTagResponseMsg(state){
        return state.message;
    },
}

const mutations = {
    updateAllTags(state, tags) {
        state.tags = tags
     },
     updateTag(state, tag) {
        state.tag = tag
     },
     updateTagResponseMsg(state, message) {
        state.message = message
     },
     updateCreatedTagId(state, tagId) {
        state.tagId = tagId
     },
}

const actions = {
    ['LOAD_ALL_TAGS']: ({commit}) => {
        return new Promise((resolve) => { 
        axios.get('tag',
        {}).then(resp => {
            if(!resp.data.error){
                commit('updateAllTags', resp.data.data)
            } else {
              console.log('Error')
            }
            resolve(resp)
            })
        })
    },

      ['GET_TAG']: ({commit}, id) => {
        return new Promise((resolve) => { 
        axios.get(`tag/${id}`, 
        {}).then(resp => {
            if(!resp.data.error){
                commit('updateTag', resp.data.data)
            } else {
              console.log(resp.data.error)
            }
            resolve(resp)
            })
        })
      },

      ['CREATE_TAG']: ({commit}, data) => {
        return new Promise((resolve) => { 
        axios.post(`tag`, { translations: data } )
        .then(resp => {
            if(!resp.data.error){
                commit('updateCreatedTag', resp.data.data.id)
                localStorage.setItem('tagId', resp.data.data.id);
                Vue.toasted.show(i18n.tc(`successfully`),{
                    theme: 'outline',
                    singleton: true,
                    position:'top-center',
                    action :
                    {
                        text : i18n.tc(`ok`),
                        onClick : (e, toastObject) => {
                            toastObject.goAway(0);
                        }  
                    }
                });
            } else {
              console.log(resp.data.error)
            }
            resolve(resp)
            })
        })
      },

      ['EDIT_TAG']: ({commit}, data) => {
        return new Promise((resolve) => { 
        axios.put(`tag/${data.tagId}`, data)
        .then(resp => {
            if(!resp.data.error){
                commit('updateTagResponseMsg', resp.data)
                Vue.toasted.show(i18n.tc(`successfully`),{
                    theme: 'outline',
                    singleton: true,
                    position:'top-center',
                    action :
                    {
                        text : i18n.tc(`ok`),
                        onClick : (e, toastObject) => {
                            toastObject.goAway(0);
                        }  
                    }
                });
            } else {
              console.log(resp.data.error)
            }
            resolve(resp)
            })
        })
      },

      ['DELETE_TAG']: ({commit}, id) => {
        return new Promise((resolve) => { 
        axios.delete(`tag/${id}`, 
        {}).then(resp => {
            if(!resp.data.error){
                commit('updateTagResponseMsg', resp.data.data)
                Vue.toasted.show(i18n.tc(`successfully`),{
                    theme: 'outline',
                    singleton: true,
                    position:'top-center',
                    action :
                    {
                        text : i18n.tc(`ok`),
                        onClick : (e, toastObject) => {
                            toastObject.goAway(0);
                        }  
                    }
                });
            } else {
              console.log(resp.data.error)
            }
            resolve(resp)
            })
        })
      },

}

export default {
    state,
    getters,
    mutations,
    actions
}